import { Colors } from "@blueprintjs/core";
import styled from "styled-components";

const AdminErrorMessage = styled.p`
  color: ${Colors.RED1};
`;

export { AdminErrorMessage };
